module.exports = __webpack_public_path__ + "img/Apoptosis-LICA_GSE146409.15519f6b.png";